import React from 'react';
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonContent,
  IonTitle,
  IonButton,
  IonModal
} from '@ionic/react';
import TermsOfService from '../custom-scripts/components/TermsOfService';

const Terms = ({isModalOpen, hideModal}) => (
  <IonModal isOpen={isModalOpen}>
    <IonHeader>
      <IonToolbar color="light">
        <IonTitle>Terms of Service</IonTitle>
        <IonButtons slot="end">
          <IonButton onClick={hideModal}>Close</IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>

    <IonContent color="light" class="menu-modal-content">
      <TermsOfService />
    </IonContent>
  </IonModal>
);

export default Terms;
